module.exports = __webpack_public_path__ + "static/5-5aea2215de1583bfbb665ae47ecc3b70.png";